import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const CollapseSec = ({
  title,
  subtitle,
  children,
  icon,
  defaultOpen = false,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="border border-gray-300 rounded-xl overflow-hidden bg-white">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between p-4 text-left"
      >
        <div className="flex gap-3 items-center">
          <span className="p-[10px] inline-block rounded-lg bg-gray-100 text-[#475467]">
            {icon}
          </span>
          <span>
            <p className="font-semibold leading-5 text-[1rem] text-gray-900">{title}</p>
            <p className="text-sm text-gray-500 leading-5">{subtitle}</p>
          </span>
        </div>

        <ChevronDown
          size={20}
          className={`transition-transform duration-[450ms] ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        className={`grid transition-all duration-[450ms] ease-in-out ${
          open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
        }`}
      >
        <div className="overflow-hidden ">
          <div className="p-4 pt-0 mt-1">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default CollapseSec;
